import { Components, Theme } from '@mui/material';

const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  styleOverrides: {
    popper: {
      zIndex: 2010,
    },

    tooltip: ({ theme }) => ({
      padding: theme.spacing(theme.spacingSizes.sm),
      fontSize: theme.fontSizes.regular,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: '16px',
    }),
  },
};

export default MuiTooltip;
